import { render, staticRenderFns } from "./coderProDemographics.vue?vue&type=template&id=46301865&"
import script from "./coderProDemographics.vue?vue&type=script&lang=js&"
export * from "./coderProDemographics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports